import { Create } from "@refinedev/mui";
import { Box, TextField } from "@mui/material";
import { useForm } from "@refinedev/react-hook-form";
import { IResourceComponentsProps } from "@refinedev/core";

export const TagCreate: React.FC<IResourceComponentsProps> = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      errorNotification: (error) => {
        return {
          message: error?.message?.includes("duplicate key value")
            ? "Tag already exist!"
            : error?.message?.includes("violates foreign key constraint")
            ? "The following tag is used in the platform and can not be deleted!"
            : "Oops! something went wrong, please try later.",
          type: "error",
        };
      },
    },
  });

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tagName", {
            required: "This field is required",
          })}
          error={!!(errors as any)?.tagName}
          helperText={(errors as any)?.tagName?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tag Name"
          name="tagName"
        />
      </Box>
    </Create>
  );
};
